import { ErrorResponse } from "../../../api/services/defs/internal-api/internal-base-request";

// The internal-api FF gate returns 403 { message: "Feature not enabled" }. When the
// admin-settings-home refresh FF is off for the target company, Tornado renders the
// legacy template; the React route must yield to it rather than crashing the page.
export const isFeatureNotEnabledError = (error: unknown): boolean => {
	if (!(error instanceof ErrorResponse)) return false;
	if (error.response.status !== 403) return false;
	const message = (error.data as { message?: unknown } | undefined)?.message;
	return typeof message === "string" && message === "Feature not enabled";
};
